import { render, staticRenderFns } from "./DisputeCaseDetailsModal.vue?vue&type=template&id=3590b580"
import script from "./DisputeCaseDetailsModal.vue?vue&type=script&lang=js"
export * from "./DisputeCaseDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DisputeCaseDetailsModal.vue?vue&type=style&index=0&id=3590b580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports